import { isPromoCodesFeatureEnabled } from 'pages/campaigns/utils';

import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import { CampaignsList, ProductCodesLink, ProductPlansList, VatRateList } from 'constants/routerPath';

import type { MenuGroup } from './types';

const processing: MenuGroup = {
    id: 'group-processing',
    title: 'Processing',
    type: 'group',
    children: [
        {
            id: 'product-codes',
            title: 'Product codes',
            type: 'item',
            url: ProductCodesLink,
            icon: ShoppingCartIcon,
            breadcrumbs: false,
            permission_name: 'product-codes',
        },
        {
            id: 'vat-rate',
            title: "VAT's list",
            type: 'item',
            url: VatRateList,
            icon: DashboardCustomizeIcon,
            breadcrumbs: false,
            permission_name: 'vat-rate',
        },
        {
            id: 'campaign',
            title: 'Campaigns',
            type: 'item',
            url: CampaignsList,
            icon: LocalOfferIcon,
            breadcrumbs: false,
            permission_name: 'campaign',
            isVisible: isPromoCodesFeatureEnabled,
        },
        {
            id: 'product-plans',
            title: 'Product plans',
            type: 'item',
            url: ProductPlansList,
            icon: DashboardCustomizeIcon,
            breadcrumbs: false,
            permission_name: 'products',
        },
    ],
};

export default processing;
